import { select } from './modules/itsSelect.js';
select();